export enum StorageKey {
    TOKEN = 'login_token',
    ORGA_AND_ROLES = 'orga_and_roles',
    SELECTED_ORGANISATION = 'selected_organisation',
    MY_ROLES = 'roles_at_selected_orga',
    CATCH_REPORT_USER = 'catch_report_user',
}
